import { render, staticRenderFns } from "./DoAccept.vue?vue&type=template&id=5ba3aa7c&scoped=true&functional=true&"
var script = {}
import style0 from "./DoAccept.vue?vue&type=style&index=0&id=5ba3aa7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5ba3aa7c",
  null
  
)

export default component.exports